import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ipService from "./ipService";

export const checkIPBlock = createAsyncThunk(
  "app/checkIPBlock",
  async (_, { rejectWithValue }) => {
    try {
      return await ipService.checkIPBlock();
    } catch (error) {
      return rejectWithValue(error.message || "Failed to check IP status");
    }
  },
);

const initialState = {
  ipBlockStatus: {
    isBlocked: false,
    blockInfo: null,
    checked: false,
  },
  isLoading: false,
  error: null,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkIPBlock.pending, (state) => {
        state.isLoading = true;
        state.ipBlockStatus.checked = false;
      })
      .addCase(checkIPBlock.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ipBlockStatus.isBlocked = action.payload.isBlocked;
        state.ipBlockStatus.blockInfo = action.payload.blockInfo;
        state.ipBlockStatus.checked = true;
      })
      .addCase(checkIPBlock.rejected, (state, action) => {
        state.isLoading = false;

        state.ipBlockStatus = {
          isBlocked: false,
          blockInfo: null,
          checked: true,
        };
        state.error = action.payload;
      });
  },
});

export default appSlice.reducer;
